import request from "@/utils/request"

export function GetOrderSettlePushPageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/OrderSettlePush/GetPageList",
    method: "post",
    data
  })
}
//手动结算订单
export function setteOrderByHand(params) {
  return request({
    url: "/Anno.Plugs.DevRun/OrderSettlePush/SetteOrderByHand",
    method: "get",
    params
  })
}
//全退结算
export function setteOrderByHand_QT(params) {
  return request({
    url: "/Anno.Plugs.DevRun/OrderSettlePush/SetteOrderByHand_QT",
    method: "get",
    params
  })
}
